var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.85 13.8984C12.3806 13.8984 12 14.279 12 14.7484C12 15.2179 12.3806 15.5984 12.85 15.5984H16.9973C17.2905 15.5984 17.5475 15.7948 17.6245 16.0778L18.6417 19.8163L21.6332 33.2146C21.873 34.2887 22.8261 35.0525 23.9267 35.0525H36.1819C37.2825 35.0525 38.2356 34.2887 38.4755 33.2146L41.0633 21.624C41.3911 20.1558 40.2741 18.762 38.7698 18.762H20.1167L19.2648 15.6314C18.9864 14.6084 18.0575 13.8984 16.9973 13.8984H12.85ZM23.2923 32.8442L20.5278 20.462H38.7698C39.1859 20.462 39.4948 20.8475 39.4041 21.2536L36.8163 32.8442C36.75 33.1413 36.4863 33.3525 36.1819 33.3525H23.9267C23.6223 33.3525 23.3586 33.1413 23.2923 32.8442ZM13.3895 23.966C13.3895 23.4966 13.7701 23.116 14.2395 23.116H15.6291C16.0985 23.116 16.4791 23.4966 16.4791 23.966C16.4791 24.4355 16.0985 24.816 15.6291 24.816L14.2395 24.816C13.7701 24.816 13.3895 24.4355 13.3895 23.966ZM26.051 41.1506C27.2022 41.1506 28.1354 40.2174 28.1354 39.0662C28.1354 37.915 27.2022 36.9818 26.051 36.9818C24.8998 36.9818 23.9666 37.915 23.9666 39.0662C23.9666 40.2174 24.8998 41.1506 26.051 41.1506ZM34.3884 41.1506C35.5396 41.1506 36.4728 40.2174 36.4728 39.0662C36.4728 37.915 35.5396 36.9818 34.3884 36.9818C33.2373 36.9818 32.3041 37.915 32.3041 39.0662C32.3041 40.2174 33.2373 41.1506 34.3884 41.1506ZM15.6291 29.6933C15.1597 29.6933 14.7791 30.0739 14.7791 30.5433C14.7791 31.0128 15.1597 31.3933 15.6291 31.3933H17.0187C17.4881 31.3933 17.8687 31.0128 17.8687 30.5433C17.8687 30.0739 17.4881 29.6933 17.0187 29.6933L15.6291 29.6933ZM12 27.2546C12 26.7851 12.3806 26.4046 12.85 26.4046H17.0187C17.4882 26.4046 17.8687 26.7851 17.8687 27.2546C17.8687 27.724 17.4882 28.1046 17.0187 28.1046H12.85C12.3806 28.1046 12 27.724 12 27.2546Z",
    fill: "url(#paint0_linear_2935_31989)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2935_31989",
    x1: 26.5604,
    y1: 13.8984,
    x2: 26.5604,
    y2: 41.1506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE3C0E",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.fbda92458b5fe1c8b98ca8adf1299013.svg";
export { ForwardRef as ReactComponent };